// extracted by mini-css-extract-plugin
export var bottomContainer = "component-module--bottomContainer--42c76";
export var contentContainer = "component-module--contentContainer--b67c1";
export var fullWidthHeadline = "component-module--fullWidthHeadline--fb0ad";
export var mainImageContainer = "component-module--mainImageContainer--e261a";
export var mediaContainer = "component-module--mediaContainer--2cce3";
export var mediaTextAdvancedContainer = "component-module--mediaTextAdvancedContainer--4ac7b";
export var mediaTextAdvancedExpandBlock = "component-module--mediaTextAdvancedExpandBlock--f3208";
export var mediaTextAdvancedSection = "component-module--mediaTextAdvancedSection--875a7";
export var noBottomMargin = "component-module--noBottomMargin--d6a0d";
export var noImg = "component-module--noImg--741c8";
export var notExtended = "component-module--notExtended--ea8a6";
export var topContainer = "component-module--topContainer--6c01d";
export var topContainerFollowedByBottomContainer = "component-module--topContainerFollowedByBottomContainer--a80cd";
export var topContainerSection = "component-module--topContainerSection--72d3e";